module.exports = __webpack_public_path__ + "img/H2.6fe9e7bf.png";